import { Typography } from "@mui/material";
import React from "react";
import uploadError from "../../../assets/images/videoUploadError.svg";
import "./videoupload.scss";
import { useNavigate } from "react-router-dom";
import { pageLocale } from "../../../utlis/locale";

const VideoUploadError = ({ styleChange }) => {
  const moduleInfo = JSON.parse(sessionStorage.getItem("fromUpload") || "");
  const navigate = useNavigate();
  const { upload_fails, retry } = pageLocale("videoUpload");
  return (
    <div className="video-upload-status-wrappper">
      {!styleChange && (
        <Typography className="title">{moduleInfo?.moduleName}</Typography>
      )}
      <div
        className={`video-upload-content-wrap + ${styleChange && `custom-change-rom`}`}
      >
        <img src={uploadError} alt="success" className="img" />
        <Typography className="success-msg">{upload_fails}</Typography>
        <button
          className="video-upload-failed-btn"
          onClick={() => navigate(-1)}
        >
          {retry}
        </button>
      </div>
    </div>
  );
};

export default VideoUploadError;
